export default __webpack_public_path__ + "static/media/edit.048d7dc5.svg";